import { BaseError } from './base-error';
/**
 * Error class with code property
 */
export class CodeError extends BaseError {
    constructor(msg, code) {
        super(msg);
        this.code = code;
    }
}
export function isCodeError(code, err) {
    return err.code === code;
}
